const Loading = () => {
    return (
    <div className="loading-spinner">
        <div></div><div></div><div></div><div></div>
    </div>)
}

export default Loading;